// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8230) return "static/chunks/8230-567d4a79e559543f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8176 ? "757b1f5f" : chunkId) + "." + {"8115":"4452c3a1cc938809","8176":"bd74bff56a35c48e","9031":"6149d78224e295f9"}[chunkId] + ".js";
};